import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/anime";

const tintMap: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700 group-hover:bg-primary-100",
  accent: "bg-accent-50 text-accent-700 group-hover:bg-accent-100",
  secondary: "bg-secondary-50 text-secondary-700 group-hover:bg-secondary-100",
};

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" aria-labelledby="category-shortcut-title">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <p className="text-[11px] font-bold tracking-[0.2em] text-accent-600 mb-2">EXPLORE</p>
          <h2 id="category-shortcut-title" className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
            按兴趣进入分类
          </h2>
        </div>
        <Link
          to="/category/guoman"
          className="hidden sm:inline-flex items-center gap-1 text-[13px] font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部分类 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categoryMeta.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center gap-3 p-3.5 md:p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
          >
            <span className={`w-10 h-10 md:w-11 md:h-11 rounded-md flex items-center justify-center shrink-0 transition-colors ${tintMap[cat.tint]}`}>
              <i className={`${cat.icon} text-lg`} />
            </span>
            <span className="min-w-0 flex flex-col">
              <span className="text-[14px] font-semibold text-foreground-950">{cat.name}</span>
              <span className="text-[11px] text-foreground-500 mt-0.5 line-clamp-1">{cat.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}